import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import CalendlyModal from "../components/CalendlyModal";
import { apiPublic } from "./api";

const CalendlyCtx = createContext(null);

export const CalendlyProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");

  useEffect(() => {
    apiPublic
      .get("/config")
      .then((r) => setUrl(r.data?.calendly_url || ""))
      .catch(() => {});
  }, []);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <CalendlyCtx.Provider value={{ open: openModal, close: closeModal, url }}>
      {children}
      <CalendlyModal open={open} onClose={closeModal} url={url} />
    </CalendlyCtx.Provider>
  );
};

export const useCalendly = () => useContext(CalendlyCtx);
